import TextField from "@/components/collections/form/TextField"
import ExpiryField from "@/components/collections/form/ExpiryField"
import CardField from "@/components/modules/hosted-pages/CardField"
import AddressComponent from "@/components/modules/hosted-pages/AddressComponent"
import ButtonField from "@/components/collections/form/ButtonComponent"
import RegionField from "@/components/collections/form/RegionField"
import SelectField from "@/components/collections/form/SelectField"
import apiClient from "@/utils/cb-client"
import Transformer from "@/utils/transformer"
import TokenizationHandler from "@/utils/tokenization-handler"
import ClientSideEncryptionHandler from "@/utils/cse-handler"
import CardCopyAddress from "@/utils/card-copy-address"
import CheckoutSubscribeComponent from "@/components/modules/hosted-pages/CheckoutSubscribeButton"
import { EventBus } from '@/utils/event-bus'
import Vue from "vue"
import CBNotification from "@/models/cb-notification"
import PaymentHelper from "@/utils/payment-helper"
import { threedsNeeded } from "@/components/modules/hosted-pages/LazyLoadPaymentComponents"
import threeDSHandler from '@/models/three-ds-handler';

import {
  mapGetters
} from "vuex"
export default {
  created() {
    PaymentHelper.setConfig(this.$store.state, this.$store.getters)
  },
	methods: {

    isMultiStepPaymentMethod() {
      return PaymentHelper.isMultiStepPaymentMethod(this.payment_method_type)
    },

    isInAppBankAccountPaymentMethod() {
      return PaymentHelper.isInAppBankAccountPaymentMethod(this.pm, this.payment_method_type)
    },

    _throwError() {
      if(this.isInAppBankAccountPaymentMethod()) {
        EventBus.$emit('_displayErrorMessage');
      } else {
        this._displayErrorMessage();
      }
    },

    showTopLevelPaymentButton() {
      if(this.isMultiStepPaymentMethod()) {
        return (this.pm_authorized);
      }
      else {
        return true;
      }
    },

    componentType() {
      switch (this.payment_method_type) {
        case "card":
          return "card-section";
        case "paypal_express_checkout":
          return "paypal-section";
        case "direct_debit":
          return "direct-debit-section";
        case "amazon_payments":
          return "amazon-payment-section";
        case "apple_pay":
          return "apple-pay-section";
      }
    },

    _sendRequest(data) {
      var replacePrimary = this.$route.name == "portal_edit_payment_method";
      return Promise.resolve().then(() => {
        if(this.pm.type=="card" && threedsNeeded(this.pm.id)) {
          return threeDSHandler(this.$store, data).then((intent) =>{
            return PaymentHelper.doApiRequest(
              { data,  pm: this.pm,  pmType: this.payment_method_type,  replacePrimary, intent }
            )
          })
        }
        else {
          this.$store.dispatch("set_payment_intent", undefined)
          return PaymentHelper.doApiRequest(
            { data,  pm: this.pm,  pmType: this.payment_method_type,  replacePrimary }
          )
        }
      });
    },

    fetchDetails() {
      return new Promise((resolve, reject) => {
        if(this.payment_method_type == "card") {
          this.$store.dispatch('validate_form', "card").then(success => {
            if(success) {
              var pmData = this.$store.getters.values("card");
              pmData['type'] = this.pm.type;
              if(this.useBillingInfo || this.useShippingInfo) {
                Object.assign(pmData, new CardCopyAddress(this.useBillingInfo ? "billing" : "shipping").copy(this.$store.state));
              }

              if(this.pm.enabled3ds) {
                resolve(pmData);
              } else if(this.pm.tokenization_config && TokenizationHandler.isTokenizationAllowed(this.pm)) {
                // if tokenization is enabled
                new TokenizationHandler(this.pm.tokenization_config).tokenize(pmData, this.$store.state.auth.customer_handle)
                .then(data => {
                  this.$store.dispatch('set_tmp_storage', {key: data.token, value: pmData});
                  resolve({tmp_token: data.token, type: this.pm.type});
                }).catch(error => reject(error))
              } else if (this.pm.client_side_encryption_config && (pmData.first_name || pmData.last_name)) {
                // if client side encryption is enabled
                // CARD_HOLDER_NAME is required field for Adyen encrypt function so we skip for empty name
                new ClientSideEncryptionHandler(this.$store, this.pm).encrypt(pmData).then(data => {
                  this.$store.dispatch('set_tmp_storage', {key: data.cipherCard, value: pmData});
                  resolve({tmp_token: data.cipherCard, type: this.pm.type});
                }).catch(error => reject(error));
              } else {
                resolve(pmData);
              }
            }
            else {
              reject({message: this.$store.getters.stranslate('error'), type: "internal"});
            }
          });
        }
        else if(this.isInAppBankAccountPaymentMethod()) {
          this.$store.dispatch('validate_form', "bank_account").then(success => {
            if(success) {
              var pmData = this.$store.getters.values("bank_account");
              pmData['type'] = this.pm.type;
              resolve(pmData);
            } else {
              reject({message: this.$store.getters.stranslate('error'), type: "internal"});
            }
          });
        } else {
          var pmData = {
            tmp_token: this.token,
            type: this.pm.type
          }
          resolve(pmData)
        }
      });
    },

    _submit() {
      return this.fetchDetails().then(data => {
        data["gateway_account_id"] = this.pm.id;
        if(this.$store.state.auth.authenticated){
          if(this.$store.getters.hosted_page_type == "portal") {
            // Set payment intent and handle 3ds
            return this._sendRequest(data);
          }
        }
        return data;
      });
    },

    addExtraMeta() {
      if(this.payment_method_type == "paypal_express_checkout") {
        return {
          meta: {
            payer_email: this.pm_email
          }
        }
      }
      else {
        return {};
      }
    },

    submitForCheckout() {
      this.showLoader = true;
      this._submit().then(data => {
        // set payment method as transient
        data.transient = true;
        this.$store.dispatch('add_transient_payment_method', data);
        this.$store.dispatch('add_payment_method', {pm: data})
        this.$store.dispatch('set_payment_method_to_order', Object.assign(data, this.addExtraMeta()));

        this.payment_method_type == "card" && window.cbTimeout(() => this.$store.dispatch('clear_form', "card"), 1000);
        this.payment_method_type != "card" && window.cbTimeout(() => this.$store.dispatch('reset_pm'), 1000);
        this.editMode ? this.$router.push({name: 'review'}) : this.$emit('next');

      }).catch(error => {
        this.showLoader = false;
        this.$store.dispatch('set_current_notification', new CBNotification('error', error));
        this._throwError();
        logger.e(error);
      });
    },

    syncSub(subHandle) {
      if(subHandle) {
        return this.$store.dispatch('load_subscription_details', subHandle);
      }
      return this.$store.dispatch('resync_subscription_details');
    },

    navigatorForPortal(pmId) {
      let canShowPaymentRole = this.hosted_page_type == "portal" && this.mpm_supported
                                && !this.$route.query.sub_handle
                                && !this.$store.getters.is_primary_pm(pmId)
                                && !this.$store.getters.is_backup_pm(pmId);
      let canRedirectActionPage = this.$store.getters.action_pages_redirect_url;
      let sameSource = this.$route.query.source == this.$route.name;
      if(sameSource && this.mpm_supported && canShowPaymentRole) {
          this.$store.dispatch('set_entry_point', "portal_assign_role_payment_method");
          this.$router.customReplace({name: "portal_assign_role_payment_method", params: {pmId: pmId}});
      } else if (sameSource && this.mpm_supported && !canShowPaymentRole) {
          this.$store.dispatch('set_entry_point', "portal_payment_methods");
          this.$router.customPush({name: "portal_payment_methods"});
      } else if (sameSource && !this.mpm_supported && canRedirectActionPage) {
          this.$store.dispatch('action_pages_redirect');
      } else if (sameSource && !this.mpm_supported && !canRedirectActionPage) {
        this.$store.dispatch('set_entry_point', "portal_view_payment_method");
        this.$router.customReplace({name: "portal_view_payment_method", params: {pmId: pmId}});
      } else if (!sameSource && this.is3DSFlowForEdgeBrowser()) {
        this.$router.customPush({name: this.$route.query.source || "home", params: {forEdgeBrowser: true, pmId: pmId}});
      } else if (!sameSource && canShowPaymentRole) {
        this.$router.customReplace({name: "portal_assign_role_payment_method", params: {pmId: pmId}});
      } else {
        this.$router.go(-1);
      }
    },

   submitForPortal(subHandle) {
      let isFailed = false;
      this.showLoader = true;
      let isUpdate = this.$route.name == "portal_edit_payment_method";
      this._submit().then(data => {
        this.$store.dispatch('add_payment_method', {pm: data.payment_source, replacePrimary: isUpdate});
        this.$store.dispatch('add_customer_data', data.customer);
        this.syncSub(subHandle).then(() => {
          if(subHandle) {
            this.$router.go(-1);
          } else {
            this.navigatorForPortal(data.payment_source.id);
          }
          this.payment_method_type == "card" && window.cbTimeout(() => this.$store.dispatch('clear_form', "card"), 1000);
          this.payment_method_type != "card" && window.cbTimeout(() => this.$store.dispatch('reset_pm'), 1000);
          this.showLoader = false;
          window.cbPostMessage({key: isUpdate ? "cb.payment_source.update" : "cb.payment_source.add", status: "success"});
        }).catch(() => {
          this.$store.dispatch('set_current_notification', new CBNotification('error', {message: 'There were errors while updating payment method.'}));
        });
      }).catch((error) => {
        isFailed = true;
        this.showLoader = false;
        this.$store.dispatch('set_current_notification', new CBNotification('error', error));
        this._throwError();
        logger.e(error);
        window.cbPostMessage({key: isUpdate ? "cb.payment_source.update" : "cb.payment_source.add", status: "error"});
      }).finally(() => {
        if(this.is3DSFlowForEdgeBrowser()) {
          this.$store.dispatch("set_back_to_entry_point", isFailed);
        }
      });
    },

    is3DSFlowForEdgeBrowser() {
      return this.pm.type=="card" && threedsNeeded(this.pm.id) && (/Edge|MSIE|Trident/.test(navigator.userAgent));
    },

    assignPaymentRoleForCust(pmId, role) {
      this.showLoader = true;
      return apiClient.customers.assign_payment_role({id: this.$store.state.auth.customer_handle},
        {
          'payment_source_id': pmId,
          'role': role
        })
        .then((data) => {
          this.showLoader = false;
          return this.$store.dispatch('update_customer_payment_roles', data.customer);
        }).catch((error) => {
          this.showLoader = false;
          this.$store.dispatch('set_current_notification', new CBNotification('error', error));
          logger.e(error);
        });
    },

    addAndSubmitForCollection() {
      this.showLoader = true;
      return this._handleCollectPayment(this._addAndSubmitForCollection);
    },

    collectWithExistingPaymentSource(promiseFn) {
      this.showLoader = true;
      return this._handleCollectPayment(this._collectWithExistingPaymentSource);
    },

    _addAndSubmitForCollection() {
      // TODO 3ds Set payment intent and handle 3ds
      return this.fetchDetails().then(data => {
        data["gateway_account_id"] = this.pm.id;
        if(this.pm.type== "card" && threedsNeeded(this.pm.id)) {
          return threeDSHandler(this.$store, data, {amount: this.$store.getters.amountToBePaid})
          .then(() => {
            return data;
          });
        }
        else {
          return this.$store.dispatch("set_payment_intent", undefined).then(() => data);
        }
      }).then((data) => {
        let apiFunc = this.isInAppBankAccountPaymentMethod()
                  ? apiClient.customers.collect_direct_debit_payment
                  : apiClient.customers.collect_payment;
        return apiFunc({id: this.$store.state.auth.customer_handle, hp_token: this.$store.state.auth.hpToken}, Transformer.collectPaymentNewSource(
          this.$store, data, {
            replace_primary_payment_source: this.replace_primary_pm,
            retain_payment_source: this.replace_primary_pm ? true : this.retain_card
          }));
      });
    },

    _collectWithExistingPaymentSource() {
      // TODO 3ds Set payment intent and handle 3ds
      return Promise.resolve().then(() => {
        if(this.payment_method.type=="card" && threedsNeeded(this.payment_method.gateway_account_id)) {
          return threeDSHandler(this.$store, this.payment_method, {amount: this.$store.getters.amountToBePaid})
          .then((intent) => {
            return apiClient.customers.collect_payment({id: this.$store.state.auth.customer_handle}, Transformer.collectPaymentWithIntent(this.$store.getters, intent.id))
          });
        }
        else {
          return this.$store.dispatch("set_payment_intent", undefined).then(() => apiClient.customers.collect_payment({id: this.$store.state.auth.customer_handle}, Transformer.collectPaymentExistingPaymentId(this.$store.getters, this.payment_source_id)));
        }
      });
    },

    _handleCollectPayment(promiseFn) {
      return promiseFn().then(data => {
        if(!(data.transaction && (data.transaction.status == "success" || data.transaction.status == "in_progress"))) {
          this.showLoader = false;
          this.$store.dispatch('set_current_notification', new CBNotification('error', {message: data.transaction.error_text || "There were errors while collecting funds. Please try again later", isDismissible: true}));
          if(!data.transaction.error_text) {
            logger.e(new Error("There were errors while collecting funds. Please try again later"));
          }
          return;
        }
        this.$store.dispatch('add_customer_data', data.customer);
        return this.$store.dispatch('load_payment_method_list');
      }).then(() => {
        this.showLoader = false;
        if(this.$store.getters.action_pages_redirect_url && ((this.$store.getters.valid_invoices.length - this.$store.getters.selected_invoices.length) == 0)) {
          this.$store.dispatch('action_pages_redirect');
        } else {
          this.$router.push({
            name: 'thankyou'
          });
        }
      }).catch((error) => {
        this.showLoader = false;
        this.$store.dispatch('set_current_notification', new CBNotification('error', error));
        logger.e(error);
      });
    },

    subscribe() {
      this.showLoader = true;
      this.fetchDetails()
      .then(data => {
        data["gateway_account_id"] = this.pm.id;
        if(this.pm.type=="card" && threedsNeeded(this.pm.id)) {
          return threeDSHandler(this.$store, data)
          .then(() => {
            return data;
          });
        }
        else {
          return this.$store.dispatch("set_payment_intent", undefined).then(() => data);
        }
      })
      .then(data => {
        if(this.$store.getters.payment_intent) {
          var transformedData = Transformer.createPaymentSourceUsingPaymentIntent(this.$store.getters.payment_intent, this.$store.state, this.$store.getters)
        }
        else if(this.payment_method_type == 'card' && !data.tmp_token){
          var transformedData = Transformer.createCardPaymentSource(this.$store.state, this.$store.getters, data)
        } else if(this.isInAppBankAccountPaymentMethod() && !data.tmp_token) {
          var transformedData = Transformer.createBankAccountPaymentSource(this.$store.state, this.$store.getters, data)
        } else {
          var transformedData = Transformer.createPaymentSourceUsingTmpToken(this.$store.state, this.$store.getters, data)
        }

        if(this.$store.state.auth.authenticated) {
          var promise = undefined;
          this.$store.dispatch('add_transient_payment_method', data);
          this.$store.dispatch('set_payment_method_to_order', data);
          if(this.is_checkout_existing) {
            promise = apiClient.subscriptions.update_bulk({
              id: this.$store.getters.subscription_handle,
              hp_token: this.$store.state.auth.hpToken
            },
            Object.assign(transformedData, Transformer.updateSubscription(this.$store.state)))
          }
          else {
            promise = apiClient.customers.create_subscription_bulk({
                id: this.$store.state.auth.customer_handle,
                hp_token: this.$store.state.auth.hpToken
              },
              Object.assign(transformedData, Transformer.createSubscriptionForCustomer(this.$store.state)))
          }
          promise.then((data) => {
            EventBus.$emit('checkout_submitted', data);
            this.showLoader = false;
            this.$router.push({
              name: 'thankyou'
            })
          })
          .catch((error) => {
            this.showLoader = false;
            this.$store.dispatch('set_current_notification', new CBNotification('error', error));
            if(this.isInAppBankAccountPaymentMethod()){
              this._throwError();
            }
            logger.e(error);
          });
        }
        else {
          this.$store.dispatch('add_transient_payment_method', data);
          this.$store.dispatch('set_payment_method_to_order', data);
          apiClient.subscriptions.create({
              hp_token: this.$store.state.auth.hpToken
            },
            Transformer.createSubscription(this.$store.state))
          .then((data) => {
            EventBus.$emit('checkout_submitted', data);
            this.showLoader = false;
            this.$router.push({
              name: 'thankyou'
            })
          })
          .catch((error) => {
            this.showLoader = false;
            this.$store.dispatch('set_current_notification', new CBNotification('error', error));
            EventBus.$emit('hp_log', {action:'checkout_failed', error:error});
            if(this.isInAppBankAccountPaymentMethod()){
              this._throwError();
            }
            logger.e(error);
          });
        }
      }).catch(error => {
        this.showLoader = false;
        this.$store.dispatch('set_current_notification', new CBNotification('error', error));
        logger.e(error);
      });
    },
    _renderRecaptcha() {
      if(this.recaptchaVerification && window.grecaptcha) {
        grecaptcha.render(this.$refs.recaptcha_container, {
          'sitekey' : this.recaptcha_key,
          'size': 'invisible',
          'hl': this.init_info_locale,
          'callback' : (token) => {
            this.showLoader = true;
            this.$store.dispatch("verify_recaptcha", token).then(() => {
              this.showLoader = false;
              this.proceed();
              grecaptcha.reset();
            }).catch((error) => {
              grecaptcha.reset();
              this.showLoader = false;
            });
          },
        });
      }
    }
	},
	data() {
		return{
      // payment_method: "card"
		}
	},
  components: {
    "cb-button": ButtonField,
    "checkout-subscribe": CheckoutSubscribeComponent
  },
  computed: {
    ...mapGetters([
      "mpm_supported",
      "pm_list",
      "pm_token",
      "pm_email",
      "pm_authorized",
      "hosted_page_type",
      "recaptcha_key",
      "init_info_locale"
    ]),
    pm() {
      return this.$store.getters.pm_by_type(this.payment_method_type);
    },
    token() {
      // For now lets use it for paypal express checkout
      return this.pm_token;
    },
    recaptchaVerification() {
      return this.$store.getters.recaptcha_modules.indexOf(this.hosted_page_type) != -1;
    }
  },
  watch: {
    payment_method_type(newValue, oldValue){
      this.swapPaymentMethod = false;
      this.$store.dispatch('set_loader', true);
      this.$nextTick(function() {
        this.swapPaymentMethod = true;
        window.cbTimeout(() => {
          this.$store.dispatch('set_loader', false);
        }, 400);//400 animation duration
      });
    }
  },
}


// WEBPACK FOOTER //
// ./src/mixins/payment-mixin.js